import { render, staticRenderFns } from "./TrustLevelTierModal.vue?vue&type=template&id=ef4dce46&scoped=true"
import script from "./TrustLevelTierModal.vue?vue&type=script&lang=js"
export * from "./TrustLevelTierModal.vue?vue&type=script&lang=js"
import style0 from "./TrustLevelTierModal.vue?vue&type=style&index=0&id=ef4dce46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4dce46",
  null
  
)

export default component.exports